import { stringIncludesInsensitiveAccents } from '../../utils/normalizeForSearch';

/**
 * Sort menu items by order property (recursive for child items)
 * @param {ApiManagerMenuItem[]} items - Array of items to sort
 * @returns {ApiManagerMenuItem[]} Sorted array with sorted children
 */
export const sortMenuItemsByOrder = (items) => {
  if (!items) return [];
  return [...items]
    // .sort((a, b) => a.order - b.order)
    .map((item) => ({
      ...item,
      ...(item.items && { items: sortMenuItemsByOrder(item.items) }),
    }));
};

/**
 * Filter menu items recursively based on search term
 * @param {ApiManagerMenuItem[]} items - Array of menu items to filter
 * @param {string} searchTerm - Search term to match against labels
 * @returns {ApiManagerMenuItem[]} Filtered array with matching items and their children
 */
export const filterMenuItemsBySearch = (items, searchTerm) => {
  if (!items || !searchTerm) return items || [];

  const normalizedSearch = searchTerm.trim();
  if (!normalizedSearch) return items;

  return items.reduce((filtered, item) => {
    const itemMatches = stringIncludesInsensitiveAccents(item.label, normalizedSearch) || false;
    const filteredChildren = item.items ? filterMenuItemsBySearch(item.items, searchTerm) : [];
    const hasMatchingChildren = filteredChildren.length > 0;

    if (itemMatches || hasMatchingChildren) {
      // If the current item matches, keep all its children
      if (itemMatches && item.items) {
        filtered.push({
          ...item,
          items: item.items,
        });
      } else {
        filtered.push({
          ...item,
          ...(item.items && { items: filteredChildren }),
        });
      }
    }

    return filtered;
  }, []);
};
